//@flow
import React from 'react';
import { connect } from 'react-redux';
import Modal from './modal';

import type { Node } from 'react';
import type { ModalAction } from '../actions';
type Props = {
    content: Node,
    footerContent: Node,
    primaryAction: ModalAction,
    secondaryAction: ModalAction,
    warningContent: Node,
    thick: boolean,
    options: Object
}

const HModal = (props: Props) => {
    let { content, primaryAction, secondaryAction, footerContent, warningContent, thick, options } = props;
    if (!content) 
        return null;
    if (!primaryAction)
        primaryAction = {};
    if (!secondaryAction)
        secondaryAction = {};
    const showModal = !!content;
    return (
        <Modal 
            shown={showModal}
            modalContent={content}
            leftBtnText={secondaryAction.text}
            leftBtnType={secondaryAction.type}
            leftBtnHandler={secondaryAction.handler}
            rightBtnText={primaryAction.text}
            rightBtnType={primaryAction.type}
            rightBtnHandler={primaryAction.handler}
            footerContent={footerContent}
            modalWarning={warningContent}
            thick={thick}
            options={options}
        />
    )
}
const mapStateToProps = ({ modal }) => ({
    ...modal
})
export default connect(mapStateToProps)(HModal);
